import _additionalItems from "./additionalItems";
import _prefixItems from "./prefixItems";
import _items from "./items";
import _items2 from "./items2020";
import _contains from "./contains";
import _dependencies from "./dependencies";
import _propertyNames from "./propertyNames";
import _additionalProperties from "./additionalProperties";
import _properties from "./properties";
import _patternProperties from "./patternProperties";
import _not from "./not";
import _anyOf from "./anyOf";
import _oneOf from "./oneOf";
import _allOf from "./allOf";
import _if from "./if";
import _thenElse from "./thenElse";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const additionalItems_1 = _additionalItems;
const prefixItems_1 = _prefixItems;
const items_1 = _items;
const items2020_1 = _items2;
const contains_1 = _contains;
const dependencies_1 = _dependencies;
const propertyNames_1 = _propertyNames;
const additionalProperties_1 = _additionalProperties;
const properties_1 = _properties;
const patternProperties_1 = _patternProperties;
const not_1 = _not;
const anyOf_1 = _anyOf;
const oneOf_1 = _oneOf;
const allOf_1 = _allOf;
const if_1 = _if;
const thenElse_1 = _thenElse;
function getApplicator(draft2020 = false) {
  const applicator = [
  // any
  not_1.default, anyOf_1.default, oneOf_1.default, allOf_1.default, if_1.default, thenElse_1.default,
  // object
  propertyNames_1.default, additionalProperties_1.default, dependencies_1.default, properties_1.default, patternProperties_1.default];
  // array
  if (draft2020) applicator.push(prefixItems_1.default, items2020_1.default);else applicator.push(additionalItems_1.default, items_1.default);
  applicator.push(contains_1.default);
  return applicator;
}
exports.default = getApplicator;
//# sourceMappingURL=index.js.map
export default exports;
export const __esModule = exports.__esModule;